

export const GET_PROVIDER_CATALOG_REQUEST = "GET_PROVIDER_CATALOG_REQUEST";
export const GET_PROVIDER_CATALOG_SUCCESS = "GET_PROVIDER_CATALOG_SUCCESS";
export const GET_PROVIDER_CATALOG_FAILURE = "GET_PROVIDER_CATALOG_FAILURE";

export const GET_PROVIDERS_REQUEST = "GET_PROVIDERS_REQUEST";
export const GET_PROVIDERS_SUCCESS = "GET_PROVIDERS_SUCCESS";
export const GET_PROVIDERS_FAILURE = "GET_PROVIDERS_FAILURE";

export const UPSERT_PROVIDER_REQUEST = "UPSERT_PROVIDER_REQUEST";
export const UPSERT_PROVIDER_SUCCESS = "UPSERT_PROVIDER_SUCCESS";
export const UPSERT_PROVIDER_FAILURE = "UPSERT_PROVIDER_FAILURE";

export const DELETE_PROVIDER_REQUEST = "DELETE_PROVIDER_REQUEST";
export const DELETE_PROVIDER_SUCCESS = "DELETE_PROVIDER_SUCCESS";
export const DELETE_PROVIDER_FAILURE = "DELETE_PROVIDER_FAILURE";

export const GET_MODEL_BINDINGS_REQUEST = "GET_MODEL_BINDINGS_REQUEST";
export const GET_MODEL_BINDINGS_SUCCESS = "GET_MODEL_BINDINGS_SUCCESS";
export const GET_MODEL_BINDINGS_FAILURE = "GET_MODEL_BINDINGS_FAILURE";

export const UPSERT_MODEL_BINDING_REQUEST = "UPSERT_MODEL_BINDING_REQUEST";
export const UPSERT_MODEL_BINDING_SUCCESS = "UPSERT_MODEL_BINDING_SUCCESS";
export const UPSERT_MODEL_BINDING_FAILURE = "UPSERT_MODEL_BINDING_FAILURE";

export const DELETE_MODEL_BINDING_REQUEST = "DELETE_MODEL_BINDING_REQUEST";
export const DELETE_MODEL_BINDING_SUCCESS = "DELETE_MODEL_BINDING_SUCCESS";
export const DELETE_MODEL_BINDING_FAILURE = "DELETE_MODEL_BINDING_FAILURE";

export const GET_AI_GATEWAY_PERMISSION_REQUEST = "GET_AI_GATEWAY_PERMISSION_REQUEST";
export const GET_AI_GATEWAY_PERMISSION_SUCCESS = "GET_AI_GATEWAY_PERMISSION_SUCCESS";
export const GET_AI_GATEWAY_PERMISSION_FAILURE = "GET_AI_GATEWAY_PERMISSION_FAILURE";

export const GET_PROVIDER_MODELS_REQUEST = "GET_PROVIDER_MODELS_REQUEST";
export const GET_PROVIDER_MODELS_SUCCESS = "GET_PROVIDER_MODELS_SUCCESS";
export const GET_PROVIDER_MODELS_FAILURE = "GET_PROVIDER_MODELS_FAILURE";

// --- catalog ---
export const getProviderCatalogRequest = () => ({ type: GET_PROVIDER_CATALOG_REQUEST });
export const getProviderCatalogSuccess = (catalog) => ({ type: GET_PROVIDER_CATALOG_SUCCESS, payload: { catalog } });
export const getProviderCatalogFailure = (error) => ({ type: GET_PROVIDER_CATALOG_FAILURE, payload: { error } });

// --- configured providers ---
export const getProvidersRequest = () => ({ type: GET_PROVIDERS_REQUEST });
export const getProvidersSuccess = (providers) => ({ type: GET_PROVIDERS_SUCCESS, payload: { providers } });
export const getProvidersFailure = (error) => ({ type: GET_PROVIDERS_FAILURE, payload: { error } });

export const upsertProviderRequest = (provider, config) => ({ type: UPSERT_PROVIDER_REQUEST, payload: { provider, config } });
export const upsertProviderSuccess = (result) => ({ type: UPSERT_PROVIDER_SUCCESS, payload: { result } });
export const upsertProviderFailure = (error) => ({ type: UPSERT_PROVIDER_FAILURE, payload: { error } });

export const deleteProviderRequest = (provider) => ({ type: DELETE_PROVIDER_REQUEST, payload: { provider } });
export const deleteProviderSuccess = (provider) => ({ type: DELETE_PROVIDER_SUCCESS, payload: { provider } });
export const deleteProviderFailure = (error) => ({ type: DELETE_PROVIDER_FAILURE, payload: { error } });

// --- model bindings ---
export const getModelBindingsRequest = () => ({ type: GET_MODEL_BINDINGS_REQUEST });
export const getModelBindingsSuccess = (bindings) => ({ type: GET_MODEL_BINDINGS_SUCCESS, payload: { bindings } });
export const getModelBindingsFailure = (error) => ({ type: GET_MODEL_BINDINGS_FAILURE, payload: { error } });

export const upsertModelBindingRequest = (capability, binding) => ({ type: UPSERT_MODEL_BINDING_REQUEST, payload: { capability, binding } });
export const upsertModelBindingSuccess = (result) => ({ type: UPSERT_MODEL_BINDING_SUCCESS, payload: { result } });
export const upsertModelBindingFailure = (error) => ({ type: UPSERT_MODEL_BINDING_FAILURE, payload: { error } });

export const deleteModelBindingRequest = (capability) => ({ type: DELETE_MODEL_BINDING_REQUEST, payload: { capability } });
export const deleteModelBindingSuccess = (capability) => ({ type: DELETE_MODEL_BINDING_SUCCESS, payload: { capability } });
export const deleteModelBindingFailure = (error) => ({ type: DELETE_MODEL_BINDING_FAILURE, payload: { error } });

// --- live provider models ---
export const getProviderModelsRequest = (provider) => ({ type: GET_PROVIDER_MODELS_REQUEST, payload: { provider } });
export const getProviderModelsSuccess = (provider, models, source) => ({ type: GET_PROVIDER_MODELS_SUCCESS, payload: { provider, models, source } });
export const getProviderModelsFailure = (provider, error) => ({ type: GET_PROVIDER_MODELS_FAILURE, payload: { provider, error } });

// --- permission ---
export const getAiGatewayPermissionRequest = () => ({ type: GET_AI_GATEWAY_PERMISSION_REQUEST });
export const getAiGatewayPermissionSuccess = (permission) => ({ type: GET_AI_GATEWAY_PERMISSION_SUCCESS, payload: { permission } });
export const getAiGatewayPermissionFailure = (error) => ({ type: GET_AI_GATEWAY_PERMISSION_FAILURE, payload: { error } });
